import { Box, Card, Skeleton, Stack } from '@mui/material'

export const CardSkeleton = () => {
  return (
    <Card
      sx={{
        borderRadius: 2,
        overflow: 'visible',
        boxShadow: 'none',
        backgroundColor: 'transparent',
      }}
    >
      {/* Main product image skeleton */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '1',
          borderRadius: 2,
          overflow: 'hidden',
          mb: 2,
        }}
      >
        <Skeleton
          animation="wave"
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ borderRadius: 1 }}
        />
      </Box>

      {/* Product details skeleton */}
      <Box sx={{ px: 0 }}>
        {/* Set description skeleton */}
        <Skeleton animation="wave" variant="text" width="60%" height={20} sx={{ mb: 1 }} />

        {/* Set items thumbnails skeleton */}
        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
          {[1, 2, 3].map((index) => (
            <Skeleton
              key={index}
              animation="wave"
              variant="rectangular"
              width={32}
              height={32}
              sx={{ borderRadius: 1, flexShrink: 0 }}
            />
          ))}
        </Stack>

        {/* Product name skeleton */}
        <Skeleton animation="wave" variant="text" width="80%" height={28} sx={{ mb: 0.5 }} />

        {/* Product price skeleton */}
        <Skeleton animation="wave" variant="text" width="40%" height={24} />
      </Box>
    </Card>
  )
}
